import _ from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'
import combineClassNames from '../../helpers/combineClassNames'
import useStyles from './class-state-label-style'

const ClassStateLabelView = (props) => {
  const {
    state,
    className,
    textClassName,
  } = props
  const { t } = useTranslation()
  const styles = useStyles()
  if (!_.includes(['booked', 'waitlist', 'full'], state)) return null
  const label = t(`ui.classStateLabel.${state}`)
  return (
    <div
      className={combineClassNames([
        styles.label,
        className,
        state === 'booked' && styles.labelBooked,
        state === 'waitlist' && styles.labelWaitlist,
        state === 'full' && styles.labelFull,
      ])}
    >
      <span
        className={combineClassNames([
          styles.labelText,
          textClassName,
          state === 'booked' && styles.labelTextBooked,
          state === 'waitlist' && styles.labelTextWaitlist,
          state === 'full' && styles.labelTextFull,
        ])}
      >
        {label}
      </span>
    </div>
  )
}

export default ClassStateLabelView
